import { InviteStatus, OptInStatus, UserStatus } from "../custom/betaExperience/api/types/enums";
const localStorageKey = "beta-exp-user-status";
export const getUserStatusFromResponse = ({ optInStatus, inviteCode, inviteStatus, keys, }) => {
    if (keys && keys.length > 0) {
        return UserStatus.Completed;
    }
    if ((inviteCode && inviteCode.length > 0) || inviteStatus == InviteStatus.Invitee) {
        return UserStatus.Invited;
    }
    if (optInStatus === OptInStatus.OptedIn) {
        return UserStatus.Registered;
    }
    return UserStatus.Unregistered;
};
export const setUserStatusLocalStorage = (userName, userStatusResponse) => {
    try {
        localStorage.setItem(`${userName}/${localStorageKey}`, JSON.stringify(userStatusResponse));
    }
    catch (e) {
        console.error("Unable to set user status locally", e);
    }
};
export const getUserStatusLocalStorage = (userName) => {
    try {
        const item = localStorage.getItem(`${userName}/${localStorageKey}`);
        if (item) {
            try {
                return JSON.parse(item);
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    catch (e) {
        console.error(e);
    }
};
export const removeUserStatusLocalStorage = (userName) => {
    try {
        localStorage.removeItem(`${userName}/${localStorageKey}`);
    }
    catch (e) {
        console.error(e);
    }
};
//# sourceMappingURL=userStatusUtils.js.map